interface DraftCloseConfirmProps {
  pendingCount: number;
  onKeepPreparing: () => void;
  onCancelPreparation: () => void;
}

export default function DraftCloseConfirm({
  pendingCount,
  onKeepPreparing,
  onCancelPreparation,
}: DraftCloseConfirmProps) {
  return (
    <div className="modal-overlay" onClick={onKeepPreparing}>
      <div
        className="modal-content game-invite-offline-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="draft-close-confirm-title"
      >
        <div className="modal-header">
          <h2 id="draft-close-confirm-title">Table en préparation</h2>
          <button type="button" className="modal-close" onClick={onKeepPreparing} aria-label="Fermer">
            ×
          </button>
        </div>
        <div className="game-invite-offline-body">
          <p>
            {pendingCount > 0
              ? `${pendingCount} joueur${pendingCount > 1 ? 's' : ''} invité${pendingCount > 1 ? 's' : ''} ou en attente`
              : 'Une invitation est en cours'}
            {' '}pour cette table.
          </p>
          <p>
            Souhaitez-vous seulement fermer cet écran (la préparation continue, visible dans
            « Tables libres ») ou annuler complètement la table et l'invitation associée ?
          </p>
        </div>
        <div className="game-invite-offline-actions">
          <button type="button" className="game-invite-offline-btn secondary" onClick={onKeepPreparing}>
            Fermer sans annuler
          </button>
          <button type="button" className="game-invite-offline-btn primary" onClick={onCancelPreparation}>
            Annuler la préparation
          </button>
        </div>
      </div>
    </div>
  );
}
